import React from "react";
import SbIcon from "./icons/domino/sb_icon";

const Sb = ({item, ttpos, lcs}) => {
    return (
        <SbIcon item={item} ttpos={ttpos} lcs={lcs}/>
    )
}

export default Sb